import { PageViewDataType } from 'src/kameleoonData';
import {
  KameleoonData,
  KameleoonVisitorDataType,
} from 'src/kameleoonData/types';

export class PageUtils {
  public static getLatest(
    pageViewData: NonNullable<KameleoonVisitorDataType[KameleoonData.PageView]>,
  ): PageViewDataType {
    return Object.values(pageViewData).reduce((latest, current) =>
      latest.timestamps[latest.timestamps.length - 1].time >
      current.timestamps[current.timestamps.length - 1].time
        ? latest
        : current,
    );
  }
}
